import type { EntitlementFrontend } from '~common/google-auth/storage/types'
import { getDoc, setDoc } from 'firebase/firestore'
import { docRef, fillDoc } from '~common/utils/firestore-helpers'
import { FirebaseError } from 'firebase/app'
import { StorageModuleDeps } from '~common/storage/types'

export interface EntitlementsStorageDeps extends StorageModuleDeps {}

export class EntitlementsStorageModule {
    constructor(private readonly deps: EntitlementsStorageDeps) {}

    async getEntitlement(userId: string): Promise<EntitlementFrontend | null> {
        const entitlementRef = docRef<EntitlementFrontend>(
            this.deps.db,
            'users',
            userId,
            'entitlements',
            'current',
        )
        try {
            const entitlementDoc = await getDoc(entitlementRef)
            return entitlementDoc.exists() ? fillDoc(entitlementDoc) : null
        } catch (error) {
            if (
                error instanceof FirebaseError &&
                error.code === 'permission-denied'
            ) {
                return null
            }
            throw error
        }
    }

    async updateEntitlement(
        userId: string,
        entitlementData: Partial<EntitlementFrontend>,
    ): Promise<void> {
        const entitlementRef = docRef<EntitlementFrontend>(
            this.deps.db,
            'users',
            userId,
            'entitlements',
            'current',
        )
        await setDoc(entitlementRef, entitlementData, { merge: true })
    }
}
